export default __webpack_public_path__ + "static/media/single-project-page-04-img17.c94f4f49.jpg";